export const capitalize = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1);
export const toTitleCase = (str: string): string =>
  str
    .split(" ")
    .map((word) => capitalize(word))
    .join(" ");

export const createWrapString =
  (lr: string, r?: string) =>
  (s?: string | null): string => {
    if (s === null || s === undefined) return "";

    return `${lr}${s}${r || lr}`;
  };
export const wrapQuotes = createWrapString(`"`);
export const noop = () => {};
export const splitByCharShift = (str: string): string[] =>
  str.split(/(?<=[a-z0-9])(?=[A-Z])|(?<=[A-Za-z])(?=\d)|(?<=\d)(?=[A-Za-z])/g);
export const pluralize = (singularNoun: string, quantity: number) =>
  quantity === 1 ? singularNoun : `${singularNoun}s`;
